import React from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";

// Define types for the props
interface Product {
  _id: string;
  name: string;
  quantity: number;
  amount: number;
}

interface CustomerAccount {
  product: Product[];
}

interface QuanProps {
  customerAccount: CustomerAccount[];
}

interface QuantityTableProps {
  quan: QuanProps;
  setOpenQuan: (open: boolean) => void;
}

const QuantityTable: React.FC<QuantityTableProps> = ({ quan, setOpenQuan }) => {
  // Aggregate products by name and sum their quantities and amounts
  const aggregateProducts = (accounts: CustomerAccount[]) => {
    const productMap = new Map<string, Product>();

    accounts.forEach(account => {
      account.product.forEach(product => {
        if (productMap.has(product.name)) {
          const existingProduct = productMap.get(product.name);
          if (existingProduct) {
            existingProduct.quantity += product.quantity;
            existingProduct.amount += product.amount;
          }
        } else {
          productMap.set(product.name, { ...product });
        }
      });
    });

    return Array.from(productMap.values());
  };

  const aggregatedProducts = aggregateProducts(quan?.customerAccount || []);

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Quantity Table</h4>
          <ImCancelCircle
            className="catCancel"
            onClick={() => setOpenQuan(false)}
          />
        </div>
        <div className="line"></div>
        <div className="invoiceTable">
          <table className="inTable">
            <thead>
              <tr className="heTble">
                <th className="sn">SN</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Amount(₦)</th>
              </tr>
            </thead>
            <tbody>
              {aggregatedProducts.map((product, index) => (
                <tr className="banBody" key={product._id}>
                  <td className="sn">{index + 1}</td>
                  <td>{product.name}</td>
                  <td>{product.quantity.toFixed(2)}</td>
                  <td>₦{product.amount.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default QuantityTable;
